import { z } from "zod";

export const otpFormSchema = z.object({
  otp_code: z
    .string()
    .min(6, { error: "Le code doit contenir 6 chiffres." })
    .max(6, { error: "Le code doit contenir 6 chiffres." })
    .regex(/^\d+$/, { error: "Le code ne doit contenir que des chiffres." }),
});

export type OtpFormData = z.infer<typeof otpFormSchema>;
